/* eslint-disable @typescript-eslint/ban-types */
import React, { ComponentProps, FC, PropsWithChildren } from 'react';
import NextLink from 'next/link';
import { styled } from 'linaria/react';
import { defaultTheme, withTheme } from '@shared/lib/theme';
interface CustomLinkProps extends ComponentProps<typeof NextLink> {
  color?: keyof typeof defaultTheme['colors']['text'] | (string & {});
  hoverColor?: keyof typeof defaultTheme['colors']['text'] | (string & {});
}
const Link: FC<PropsWithChildren<CustomLinkProps>> = ({
  children,
  color = 'accent',
  hoverColor = 'accent',
  ...props
}) => <LinkWrapper color={color} hoverColor={hoverColor}>
    <NextLink {...props}>{children}</NextLink>
  </LinkWrapper>;
export default Link;
const _exp = /*#__PURE__*/() => ({
  color,
  theme
}) => color in theme.colors.text ? theme.colors.text[color] : color;
const _exp2 = /*#__PURE__*/() => ({
  hoverColor,
  theme
}) => hoverColor in theme.colors.text ? theme.colors.text[hoverColor] : hoverColor;
const _exp3 = /*#__PURE__*/() => ({
  hoverColor,
  theme
}) => hoverColor in theme.colors.text ? theme.colors.text[hoverColor] : hoverColor;
const LinkWrapper = withTheme(/*#__PURE__*/styled('span')({
  name: "LinkWrapper",
  class: "l1kdm2e7",
  propsAsIs: false,
  vars: {
    "l1kdm2e7-0": [_exp()],
    "l1kdm2e7-1": [_exp2()],
    "l1kdm2e7-2": [_exp3()]
  }
}));

require("./Link.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Link.tsx");